import { trpc } from '@/shared/api/trpc';

type Options = {
  enabled?: boolean;
};

// Distinct operator countries + cities for the org — sources the Tour
// Operators panel Country / City filter dropdowns (v2 parity).
export const useTourOperatorLocationsData = (options?: Options) =>
  trpc.operations.tourOperatorLocations.useQuery(undefined, {
    enabled: options?.enabled ?? true,
  });
